import { AccessRoleType, RolesKeyType } from "types/auth/role/RoleType";

export const ROLES_KEY: RolesKeyType = {
  ROLE_LIBRARY_FULL_ACCESS: {
    category: "library",
    feature: "fullAccess",
  },
  ROLE_LIBRARY_IMPORT_LOCAL_FILE: {
    category: "library",
    feature: "importLocalFile",
  },
  ROLE_LIBRARY_READ_DATASET: {
    category: "library",
    feature: "readDataset",
  },
  ROLE_LIBRARY_EDIT_DATASET_METADATA: {
    category: "library",
    feature: "editDatasetMetadata",
  },
  ROLE_LIBRARY_UPDATE_DATASET_VERSION: {
    category: "library",
    feature: "updateDatasetVersion",
  },
  ROLE_LIBRARY_DELETE_DATASET: {
    category: "library",
    feature: "deleteDataset",
  },
  ROLE_LIBRARY_EXPORT_DATASET: {
    category: "library",
    feature: "exportDataset",
  },
  ROLE_LIBRARY_BROWSER_DOWNLOAD: {
    category: "library",
    feature: "browserDownload",
  },
  ROLE_LIBRARY_VIEW_EXPORT_LOG: {
    category: "library",
    feature: "viewExportLog",
  },
  ROLE_LIBRARY_SHARE_DATASET: {
    category: "library",
    feature: "shareDataset",
  },

  ROLE_PROJECTS_FULL_ACCESS: { category: "projects", feature: "fullAccess" },
  ROLE_PROJECTS_CREATE_PROJECT: {
    category: "projects",
    feature: "createProject",
  },
  ROLE_PROJECTS_READ_PROJECT: { category: "projects", feature: "readProject" },
  ROLE_PROJECTS_EDIT_PROJECT_METADATA: {
    category: "projects",
    feature: "editProjectMetadata",
  },
  ROLE_PROJECTS_DELETE_PROJECT: {
    category: "projects",
    feature: "deleteProject",
  },
  ROLE_PROJECTS_UPDATE_PROJECT_VERSION: {
    category: "projects",
    feature: "updateProjectVersion",
  },
  ROLE_PROJECTS_PUBLISH_PROJECT: {
    category: "projects",
    feature: "publishProject",
  },
  ROLE_PROJECTS_SHARE_PROJECT: {
    category: "projects",
    feature: "shareProject",
  },

  ROLE_USERS_CREATE_USERS: { category: "users", feature: "createUsers" },
  ROLE_USERS_VIEW_USERS: { category: "users", feature: "viewUsers" },
  ROLE_USERS_MODIFY_USERS: { category: "users", feature: "modifyUsers" },
  ROLE_USERS_DELETE_USERS: { category: "users", feature: "deleteUsers" },

  ROLE_GROUPS_CREATE_UPDATE_DELETE_GROUPS: {
    category: "groups",
    feature: "createUpdateDeleteGroups",
  },
  ROLE_GROUPS_VIEW_GROUP_DETAILS: {
    category: "groups",
    feature: "viewGroupDetails",
  },
  ROLE_GROUPS_ADD_REMOVE_USERS_FROM_A_GROUP: {
    category: "groups",
    feature: "addRemoveUsersFromAGroup",
  },

  ROLE_ROLES_CREATE_ROLES: { category: "roles", feature: "createRoles" },
  ROLE_ROLES_VIEW_ROLES: { category: "roles", feature: "viewRoles" },
  ROLE_ROLES_MODIFY_ROLES: { category: "roles", feature: "modifyRoles" },
  ROLE_ROLES_DELETE_ROLES: { category: "roles", feature: "deleteRoles" },

  ROLE_ADMINISTRATION_DOMAIN_SETTINGS: {
    category: "administration",
    feature: "domainSettings",
  },
  ROLE_ADMINISTRATION_VIEW_USER_LOGS: {
    category: "administration",
    feature: "viewUserLogs",
  },

  ROLE_CONNECTORS_FULL_ACCESS: {
    category: "connectors",
    feature: "fullAccess",
  },
  ROLE_CONNECTORS_CREATE_CONNECTOR: {
    category: "connectors",
    feature: "createConnector",
  },
  ROLE_CONNECTORS_DELETE_CONNECTOR: {
    category: "connectors",
    feature: "deleteConnector",
  },
  ROLE_CONNECTORS_READ_CONNECTOR: {
    category: "connectors",
    feature: "readConnector",
  },
  ROLE_CONNECTORS_UPDATE_CONNECTOR: {
    category: "connectors",
    feature: "updateConnector",
  },

  ROLE_CONNECTORS_SHARE_CONNECTOR: {
    category: "connectors",
    feature: "shareConnector",
  },

  ROLE_DATA_SOURCES_FULL_ACCESS: {
    category: "dataSources",
    feature: "fullAccess",
  },
  ROLE_DATA_SOURCES_CREATE_DATASOURCE: {
    category: "dataSources",
    feature: "createDatasource",
  },
  ROLE_DATA_SOURCES_DELETE_DATASOURCE: {
    category: "dataSources",
    feature: "deleteDatasource",
  },
  ROLE_DATA_SOURCES_EXPORT_DATASOURCE: {
    category: "dataSources",
    feature: "exportDatasource",
  },
  ROLE_DATA_SOURCES_IMPORT_DATASOURCE: {
    category: "dataSources",
    feature: "importDatasource",
  },
  ROLE_DATA_SOURCES_READ_DATASOURCE: {
    category: "dataSources",
    feature: "readDatasource",
  },
  ROLE_DATA_SOURCES_UPDATE_DATASOURCE: {
    category: "dataSources",
    feature: "updateDatasource",
  },
  ROLE_DATA_SOURCES_SHARE_DATASOURCE: {
    category: "dataSources",
    feature: "shareDatasource",
  },
  ROLE_PROJECT_FLOWS_FULL_ACCESS: {
    category: "projectFlows",
    feature: "fullAccess",
  },
  ROLE_PROJECT_FLOWS_CREATE_FLOWS: {
    category: "projectFlows",
    feature: "createFlows",
  },
  ROLE_PROJECT_FLOWS_DELETE_FLOWS: {
    category: "projectFlows",
    feature: "deleteFlows",
  },
  ROLE_PROJECT_FLOWS_RUN_FLOWS: {
    category: "projectFlows",
    feature: "runFlows",
  },
  ROLE_PROJECT_FLOWS_VIEW_FLOWS: {
    category: "projectFlows",
    feature: "viewFlows",
  },

  ROLE_PROJECT_FLOWS_EDIT_FLOWS_METADATA: {
    category: "projectFlows",
    feature: "editFlowsMetaData",
  },
  ROLE_PROJECT_FLOWS_SHARE_FLOWS: {
    category: "projectFlows",
    feature: "shareFlows",
  },
  ROLE_REPORT_FULL_ACCESS: {
    category: "report",
    feature: "fullAccess",
  },
  ROLE_REPORT_CREATE_REPORT: {
    category: "report",
    feature: "createReport",
  },
  ROLE_REPORT_READ_REPORT: {
    category: "report",
    feature: "readReport",
  },
  ROLE_REPORT_UPDATE_REPORT: {
    category: "report",
    feature: "updateReportVersion",
  },
  ROLE_REPORT_EDIT_REPORT_METADATA: {
    category: "report",
    feature: "editReportMetadata",
  },
  ROLE_REPORT_DELETE_REPORT: {
    category: "report",
    feature: "deleteReport",
  },
  ROLE_REPORT_PUBLISH_REPORT: {
    category: "report",
    feature: "publishReport",
  },
};

export const DEFAULT_ACCESS_ROLE: AccessRoleType = {
  administration: {
    domainSettings: false,
    viewUserLogs: false,
  },
  users: {
    createUsers: false,
    viewUsers: false,
    modifyUsers: false,
    deleteUsers: false,
  },
  groups: {
    createUpdateDeleteGroups: false,
    viewGroupDetails: false,
    addRemoveUsersFromAGroup: false,
  },
  roles: {
    createRoles: false,
    viewRoles: false,
    modifyRoles: false,
    deleteRoles: false,
  },
  connectors: {
    fullAccess: false,
    createConnector: false,
    readConnector: false,
    updateConnector: false,
    deleteConnector: false,
    shareConnector: false,
  },
  library: {
    fullAccess: false,
    importLocalFile: false,
    readDataset: false,
    editDatasetMetadata: false,
    updateDatasetVersion: false,
    deleteDataset: false,
    exportDataset: false,
    browserDownload: false,
    viewExportLog: false,
    shareDataset: false,
  },
  dataSources: {
    fullAccess: false,
    createDatasource: false,
    readDatasource: false,
    updateDatasource: false,
    deleteDatasource: false,
    importDatasource: false,
    exportDatasource: false,
    shareDatasource: false,
  },
  projects: {
    fullAccess: false,
    createProject: false,
    readProject: false,
    editProjectMetadata: false,
    deleteProject: false,
    updateProjectVersion: false,
    publishProject: false,
    shareProject: false,
  },
  projectFlows: {
    fullAccess: false,
    createFlows: false,
    editFlowsMetaData: false,
    viewFlows: false,
    deleteFlows: false,
    runFlows: false,
    shareFlows: false,
  },
  report: {
    fullAccess: false,
    createReport: false,
    readReport: false,
    editReportMetadata: false,
    deleteReport: false,
    updateReportVersion: false,
    publishReport: false,
    shareReport: false,
  },
};
